'use strict';

const personalIdFormat = /^(\d{2})?(\d{6})-?(\d{4})$/;

export default function formatPersonalId(value) {
    return value.replace(/ /g, '').replace(personalIdFormat, '$2-$3');
}
